<div class="auth">

  <form class="auth-form" name="form" (ngSubmit)="f.form.valid && resetPassword()" #f="ngForm" novalidate>
    <h2 class="text-center">Reset hasła:</h2>

    <label [ngClass]="{ 'has-error': f.submitted && !username.valid }">LOGIN:
      <input type="text" class="text-center" name="login" [(ngModel)]="model.username" #username="ngModel" required>
    </label>

    <a routerLink="/login">Logowanie</a>

    <button [disabled]="loading" (click)="resetPassword()" class="text-center">Reset</button>
  </form>
</div>
